export const TIMBERLAND_REDIRECT_URL_EN_GB = 'https://www.timberland.co.uk/homepage.html';
export const TIMBERLAND_REDIRECT_URL_EN_IE = 'https://www.timberland.ie/homepage.html';
export const TIMBERLAND_REDIRECT_URL_EN_CH = 'https://www.timberland.ch/en_ch/homepage.html';
export const TIMBERLAND_REDIRECT_URL_EN_DK = 'https://www.timberland.dk/homepage.html';
export const TIMBERLAND_REDIRECT_URL_EN_SE = 'https://www.timberland.se/homepage.html';
export const TIMBERLAND_REDIRECT_URL_EN_FI = 'https://www.timberland.ie/homepage.html';
export const TIMBERLAND_REDIRECT_URL_EN_IS = 'https://www.timberland.ie/homepage.html';

export const TIMBERLAND_REDIRECT_URL_DE_DE = 'https://www.timberland.de/homepage.html';
export const TIMBERLAND_REDIRECT_URL_DE_AT = 'https://www.timberland.at/homepage.html';
export const TIMBERLAND_REDIRECT_URL_DE_CH = 'https://www.timberland.ch/homepage.html';
export const TIMBERLAND_REDIRECT_URL_DE_BE = 'https://www.timberland.be/de_be/homepage.html';

export const TIMBERLAND_REDIRECT_URL_ES_ES = 'https://www.timberland.es/homepage.html';

export const TIMBERLAND_REDIRECT_URL_FR_FR = 'https://www.timberland.fr/homepage.html';
export const TIMBERLAND_REDIRECT_URL_FR_CH = 'https://www.timberland.ch/fr_ch/homepage.html';
export const TIMBERLAND_REDIRECT_URL_FR_BE = 'https://www.timberland.be/fr_be/homepage.html';

export const TIMBERLAND_REDIRECT_URL_IT_IT = 'https://www.timberland.it/homepage.html';
export const TIMBERLAND_REDIRECT_URL_IT_CH = 'https://www.timberland.ch/it_ch/homepage.html';

export const TIMBERLAND_REDIRECT_URL_NL_NL = 'https://www.timberland.nl/homepage.html';
export const TIMBERLAND_REDIRECT_URL_NL_BE = 'https://www.timberland.be/homepage.html';
